import React, { useId } from 'react';
import AccountPanel from './AccountPanel';
import ModalShell from './ModalShell';
import type { AccountNotice } from '../util/authEvents';
import './AccountModal.scss';

/**
 * My Account as a modal. The container is `ModalShell` — the same one AuthModal uses — and the
 * contents are `AccountPanel`, the same component the `/settings` page renders. This file is
 * only the skin: how wide the dialog is and how its body is padded.
 */
export default function AccountModal({
  isOpen,
  onClose,
  onExited,
  notice = null
}: {
  isOpen: boolean;
  onClose: () => void;
  onExited?: () => void;
  /** Why it opened, when the user did not open it themselves (see AuthLauncher). */
  notice?: AccountNotice | null;
}) {
  const headingId = useId();

  return (
    <ModalShell
      isOpen={ isOpen }
      onClose={ onClose }
      onExited={ onExited }
      labelledBy={ headingId }
      overlayClassName="account-modal-overlay"
      className="account-modal"
    >
      <div className="account-modal-body">
        { /* Signing out closes the dialog and leaves you exactly where you were — with your image,
             slices and layers intact. You are simply anonymous from here on. `frozen` keeps the
             account on screen for the 300ms fade, instead of collapsing to "Sign in to see your
             account" and shrinking the dialog as it goes. */ }
        <AccountPanel headingId={ headingId } onSignedOut={ onClose } frozen={ !isOpen } notice={ notice } />
      </div>
    </ModalShell>
  );
}
